import { ErrorState } from "@dexibit/core";

const ErrorFallback = () => {
  return (
    <ErrorState
      title={"Oops, something went wrong."}
      description="Please refresh your page or try again later."
    />
  );
};

export default ErrorFallback;
